<template>
  <material-card>
    <v-layout px-3 slot="header">
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Historia</div>

        <p>Informacje o wykonanych akcjach</p>
      </v-flex>
    </v-layout>

    <material-table
      :headers="table.headers"
      :items="list"
      :actions="false"
      :hideActions="false"
      :total-count="count"
      @pagination="reloadList"
    ></material-table>
  </material-card>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { HistoryActionType, HistoryActionTypeTranslation } from '@witkac/kartamiejska-shared';

import MaterialTable from '@/components/material/Table';
import { listMixin } from '@/mixins/list';
import MaterialCard from '@/components/material/Card';
import { DEFAULT_LIST_COUNT } from '@/utils/constants';

// @vuese
// Wyświetlanie zakładki historii
export default {
  data() {
    return {
      table: {
        headers: [
          { value: 'date', text: 'Data', sortable: true, paginationValue: 'created' },
          { value: 'actionTransalte', text: 'Rodzaj', sortable: true, paginationValue: 'action' },
          { value: 'changesFiltered', text: 'Opis', sortable: false }
        ]
      }
    };
  },
  components: {
    MaterialCard,
    MaterialTable
  },
  props: {
    // Czy pobierac historie partnera
    getPartner: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [
    listMixin(
      'entityHistory',
      {
        listError: 'Wystąpił błąd podczas pobierania historii.'
      },
      {},
      (to, from, next) => {
        next();
      }
    )
  ],
  computed: {
    ...mapState({
      list: state =>
        state.entityHistory.list.map(historyLog => {
          historyLog.date = moment(historyLog.created).format('YYYY-MM-DD HH:mm');
          historyLog.actionTransalte = HistoryActionTypeTranslation[historyLog.action];
          historyLog.changesFiltered = historyLog.json || !historyLog.changes ? 'BRAK' : historyLog.changes;
          return historyLog;
        })
    })
  },
  methods: {
    // @vuese
    // Tworzy filtry na podstawie paginacji
    filters(pagination) {
      pagination.entityId = this.$route.params.id;
      return { ...pagination, tableName: this.getPartner ? 'Partner' : 'Profile' };
    }
  }
};
</script>
